import { controversies } from "@/mocks/controversies";

export default function Controversy() {
  return (
    <section id="focus" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <p className="font-bebas text-sm tracking-[0.2em] text-primary-500">KEY CONTROVERSY</p>
          <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
            争议焦点 · <span className="text-primary-500">正反声音对垒</span>
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            围绕哇偶姐姐最热的几大争议点，整理支持与反对两方的代表性观点，帮你在站队前先看清全貌。
          </p>
        </div>

        <div className="mt-9 space-y-6">
          {controversies.map((c) => (
            <article
              key={c.id}
              className="overflow-hidden rounded-2xl border border-background-200 bg-background-50"
            >
              <div className="flex flex-col gap-3 border-b border-background-200 bg-background-100/60 p-5 md:flex-row md:items-center md:justify-between md:p-6">
                <div className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                    <i className="ri-question-line" aria-hidden="true" />
                  </span>
                  <div>
                    <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                      {c.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-6 text-foreground-600">{c.summary}</p>
                  </div>
                </div>
                <span className="inline-flex w-fit shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900 md:ml-4">
                  <i className="ri-fire-fill" aria-hidden="true" /> {c.heat} · {c.tag}
                </span>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2">
                <div className="border-b border-background-200 p-5 md:border-b-0 md:border-r md:p-6">
                  <p className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                    <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                      <i className="ri-thumb-up-line text-xs" aria-hidden="true" />
                    </span>
                    支持方怎么看
                  </p>
                  <ul className="mt-4 space-y-3">
                    {c.pro.map((v, i) => (
                      <li key={i} className="flex gap-3 rounded-lg bg-primary-50 p-3">
                        <i className="ri-double-quotes-l mt-0.5 text-primary-400" aria-hidden="true" />
                        <div>
                          <p className="text-sm leading-6 text-foreground-800">{v.view}</p>
                          <p className="mt-1 text-xs text-foreground-500">—— {v.user}</p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="p-5 md:p-6">
                  <p className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                    <span className="flex h-6 w-6 items-center justify-center rounded-full bg-secondary-100 text-secondary-900">
                      <i className="ri-thumb-down-line text-xs" aria-hidden="true" />
                    </span>
                    反对方怎么看
                  </p>
                  <ul className="mt-4 space-y-3">
                    {c.con.map((v, i) => (
                      <li key={i} className="flex gap-3 rounded-lg bg-secondary-100/70 p-3">
                        <i className="ri-double-quotes-l mt-0.5 text-secondary-500" aria-hidden="true" />
                        <div>
                          <p className="text-sm leading-6 text-foreground-800">{v.view}</p>
                          <p className="mt-1 text-xs text-foreground-500">—— {v.user}</p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}